type Props = {
  size: number;
};

const History = ({ size }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.99168 5.43611C6.48427 3.84342 8.47508 2.80693 10.6358 2.49756C12.7966 2.18819 14.9982 2.62441 16.8778 3.73428C18.7573 4.84416 20.2025 6.56142 20.9751 8.60291C21.7476 10.6444 21.8014 12.8882 21.1275 14.9644C20.4537 17.0405 19.0924 18.825 17.2682 20.0237C15.4439 21.2223 13.2657 21.7635 11.0926 21.558C8.91955 21.3525 6.88138 20.4126 5.3142 18.8932C3.74702 17.3739 2.7444 15.3658 2.47168 13.2001"
        stroke="#555757"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 7.21191V11.9999L15.576 15.7559"
        stroke="#555757"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.59973 7.24793H2.92773V3.57593"
        stroke="#555757"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default History;
